// extracted by mini-css-extract-plugin
export var gif = "_fd-0";